export var BufferMessageType;
(function (BufferMessageType) {
    BufferMessageType[BufferMessageType["TymeSync"] = 0] = "TymeSync";
    BufferMessageType[BufferMessageType["TimeSyncAnswer"] = 1] = "TimeSyncAnswer";
    BufferMessageType[BufferMessageType["CreateObject"] = 2] = "CreateObject";
    BufferMessageType[BufferMessageType["RemoveObject"] = 3] = "RemoveObject";
    BufferMessageType[BufferMessageType["SyncData"] = 4] = "SyncData";
    BufferMessageType[BufferMessageType["RPC"] = 5] = "RPC";
    BufferMessageType[BufferMessageType["RoomChanged"] = 6] = "RoomChanged";
    BufferMessageType[BufferMessageType["BusMsg"] = 7] = "BusMsg";
})(BufferMessageType || (BufferMessageType = {}));
